import { displaySourceLabel } from './chatSources';
import type { AiAssistantPreviewDocument, AiAssistantSource } from './types';

export type OpenAssistantSourceCallbacks = {
  onCloseDocument?: () => void;
  onNavigate?: (to: string) => void;
  onOpenDocument?: (document: AiAssistantPreviewDocument) => void;
};

/** Routes a sources-panel card action through the appropriate consumer callback. */
export function openAssistantSource(
  source: AiAssistantSource,
  callbacks: OpenAssistantSourceCallbacks
): void {
  if (source.kind === 'page') {
    callbacks.onCloseDocument?.();
    callbacks.onNavigate?.(source.to);
    return;
  }

  if (source.file || source.documentId) {
    callbacks.onOpenDocument?.({
      label: displaySourceLabel(source.label),
      file: source.file ?? '',
      documentId: source.documentId,
      pages: source.pages,
      metadata: source.metadata,
      provenance: source.provenance,
    });
  }
}
